module.exports = __webpack_public_path__ + "img/fullscreen-gofull.b680bc8f.svg";